import * as Yup from 'yup';
import { TFunction } from 'i18next';
import Input from '@lib/components/Input/Input';
import RadioButtonGroup, {
  RadioButtonWrapViews,
} from '@lib/components/RadioButtonGroup/RadioButtonGroup';
import RadioButtonAsChipColor from '@lib/components/RadioButtonAsChipColor/RadioButtonAsChipColor';
import { MAX_TEXT_FIELD_LENGTH } from '@lib/enums/form';
import { getOptionShape } from '@lib/utils/validationUtils';
import { FieldItem } from '@lib/interfaces/form';
import FormTemplateCategoryFieldNames from '@lib/enums/fieldNames/formTemplateCategoryFieldNames';
import getChipTypesOptions from '@lib/components/Chip/utils/getChipTypesOptions';

type IndustryFormFieldsArgs = {
  t: TFunction<'translation', undefined>;
};

export default function getCategoryFormFields({
  t,
}: IndustryFormFieldsArgs): FieldItem[] {
  return [
    {
      name: FormTemplateCategoryFieldNames.Name,
      label: t('category-name'),
      element: Input,
      validation: Yup.string()
        .trim()
        .max(MAX_TEXT_FIELD_LENGTH, t('max-text-length-field-error'))
        .required(t('required-field-error')),
      componentProps: {
        autoFocus: true,
      },
    },
    {
      name: FormTemplateCategoryFieldNames.Color,
      label: t('label-color'),
      element: RadioButtonGroup,
      validation: Yup.object()
        .shape(getOptionShape(t, true))
        .required(t('required-field-error')),
      componentProps: {
        options: getChipTypesOptions({ t }),
        RadioButtonComponent: RadioButtonAsChipColor,
        wrapView: RadioButtonWrapViews.colors,
      },
    },
  ];
}
